"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arrayMax = void 0;
/**
 * zwraca maksymalną wartość
 * @param values tablica wartości
 * @param prop sprawdzane property
 */
function arrayMax(values, prop) {
    let result = values[0];
    let i = values.length;
    if (prop) {
        while (--i > 0) {
            const $v = values[i][prop];
            if ($v > result) {
                result = $v;
            }
        }
    }
    else {
        while (--i > 0) {
            if (values[i] > result) {
                result = values[i];
            }
        }
    }
    return result;
}
exports.arrayMax = arrayMax;
//# sourceMappingURL=arrayMax.js.map